import { IAGAlertManagerDataRow } from "@pulse-ui/types/components/AGTable";
import { IAlertForm } from "../AlertManager.types";

const INTS_TO_PARSE = [
  "retry_backoff",
  "minutes",
  "cooldown_period_minutes",
  "stale_period_minutes",
  "delay_time_seconds",
];

export const transformCheckType = (checkType: string): string => {
  let baseString: string = checkType;
  if (baseString.includes("_config"))
    baseString = checkType.replace("_check_config", "");

  const words = baseString.split("_");
  const capitalizedWords = words.map(
    (word) => word.charAt(0).toUpperCase() + word.slice(1)
  );
  return capitalizedWords.join(" ");
};

export const parseDashedFieldNames = (field: string): string => {
  if (field) {
    return field
      .split("_")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1, word.length))
      .join(" ");
  }
  return field;
};

export const processBody = (data: Record<string, any>): Record<string, any> => {
  const newData = { ...data };

  const parseAndAssignInts = (key: string) => {
    if (typeof newData[key] === "string") {
      const parsedValue = parseInt(newData[key], 10);
      if (!isNaN(parsedValue)) {
        newData[key] = parsedValue;
      } else {
        delete newData[key];
      }
    }
  };

  if (newData.notional_check_type)
    newData["notional_check_type"] = newData.notional_check_type.toLowerCase();

  if (newData.position_side)
    newData["position_side"] = newData.position_side.toLowerCase();

  INTS_TO_PARSE.forEach(parseAndAssignInts);

  return newData;
};

export const mapRowToAlertForm = (
  row: IAGAlertManagerDataRow,
  view: string
): IAlertForm | undefined => {
  if (!row) return undefined;

  let temp_alert_form: IAlertForm = { ...row.original_row } as IAlertForm;

  for (let key in row.original_row) {
    if (key === "name") {
      temp_alert_form[key] =
        view === "duplicate"
          ? `${row.original_row[key]} copy`
          : (row.original_row[key] as string);
    } else if (INTS_TO_PARSE.includes(key)) {
      temp_alert_form[key] = (row.original_row[key] as any)?.toString();
    } else if (key === "notional_check_type") {
      temp_alert_form[key] = (row.original_row[key] as any)
        ?.toLocaleString()
        .toUpperCase();
    } else if (key in temp_alert_form) {
      temp_alert_form[key] = row.original_row[key] as any;
    }
  }

  return temp_alert_form;
};
